import { render, staticRenderFns } from "./AddWeightStationRegistrationModal.vue?vue&type=template&id=037f39ea&"
import script from "./AddWeightStationRegistrationModal.vue?vue&type=script&lang=js&"
export * from "./AddWeightStationRegistrationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports